/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createEnedisConnectionConfiguration } from '../fn/enedis-connection/create-enedis-connection-configuration';
import { CreateEnedisConnectionConfiguration$Params } from '../fn/enedis-connection/create-enedis-connection-configuration';
import { EnedisAcquisitionStatusesPagedList } from '../models/enedis-acquisition-statuses-paged-list';
import { EnedisConnectionConfig } from '../models/enedis-connection-config';
import { EnedisConnectionConfigList } from '../models/enedis-connection-config-list';
import { EnedisConnectionErrorHistoryPagedList } from '../models/enedis-connection-error-history-paged-list';
import { exportEnedisConnectionTags } from '../fn/enedis-connection/export-enedis-connection-tags';
import { ExportEnedisConnectionTags$Params } from '../fn/enedis-connection/export-enedis-connection-tags';
import { getEnedisAcquisitionStatuses } from '../fn/enedis-connection/get-enedis-acquisition-statuses';
import { GetEnedisAcquisitionStatuses$Params } from '../fn/enedis-connection/get-enedis-acquisition-statuses';
import { getEnedisConnectionConfigurations } from '../fn/enedis-connection/get-enedis-connection-configurations';
import { GetEnedisConnectionConfigurations$Params } from '../fn/enedis-connection/get-enedis-connection-configurations';
import { getEnedisConnectionErrorHistory } from '../fn/enedis-connection/get-enedis-connection-error-history';
import { GetEnedisConnectionErrorHistory$Params } from '../fn/enedis-connection/get-enedis-connection-error-history';
import { getEnedisErrorHistory } from '../fn/enedis-connection/get-enedis-error-history';
import { GetEnedisErrorHistory$Params } from '../fn/enedis-connection/get-enedis-error-history';
import { importEnedisConnectionTags } from '../fn/enedis-connection/import-enedis-connection-tags';
import { ImportEnedisConnectionTags$Params } from '../fn/enedis-connection/import-enedis-connection-tags';
import { listEnedisConnectionConfigurations } from '../fn/enedis-connection/list-enedis-connection-configurations';
import { ListEnedisConnectionConfigurations$Params } from '../fn/enedis-connection/list-enedis-connection-configurations';
import { removeEnedisConnectionConfiguration } from '../fn/enedis-connection/remove-enedis-connection-configuration';
import { RemoveEnedisConnectionConfiguration$Params } from '../fn/enedis-connection/remove-enedis-connection-configuration';
import { updateEnedisConnectionConfiguration } from '../fn/enedis-connection/update-enedis-connection-configuration';
import { UpdateEnedisConnectionConfiguration$Params } from '../fn/enedis-connection/update-enedis-connection-configuration';


/**
 * All about the enedis connections
 */
@Injectable({ providedIn: 'root' })
export class EnedisConnectionService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listEnedisConnectionConfigurations()` */
  static readonly ListEnedisConnectionConfigurationsPath = '/stations/{uid}/enedis';

  /**
   * List a station Enedis connections configurations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listEnedisConnectionConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEnedisConnectionConfigurations$Response(params: ListEnedisConnectionConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<EnedisConnectionConfigList>> {
    return listEnedisConnectionConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * List a station Enedis connections configurations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listEnedisConnectionConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEnedisConnectionConfigurations(params: ListEnedisConnectionConfigurations$Params, context?: HttpContext): Observable<EnedisConnectionConfigList> {
    return this.listEnedisConnectionConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<EnedisConnectionConfigList>): EnedisConnectionConfigList => r.body)
    );
  }

  /** Path part for operation `createEnedisConnectionConfiguration()` */
  static readonly CreateEnedisConnectionConfigurationPath = '/stations/{uid}/enedis';

  /**
   * Create a station Enedis connection configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createEnedisConnectionConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEnedisConnectionConfiguration$Response(params: CreateEnedisConnectionConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createEnedisConnectionConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a station Enedis connection configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createEnedisConnectionConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEnedisConnectionConfiguration(params: CreateEnedisConnectionConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.createEnedisConnectionConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getEnedisConnectionConfigurations()` */
  static readonly GetEnedisConnectionConfigurationsPath = '/stations/{uid}/enedis/{enedisUid}';

  /**
   * Get a station Enedis connection configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEnedisConnectionConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnedisConnectionConfigurations$Response(params: GetEnedisConnectionConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<EnedisConnectionConfig>> {
    return getEnedisConnectionConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a station Enedis connection configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEnedisConnectionConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnedisConnectionConfigurations(params: GetEnedisConnectionConfigurations$Params, context?: HttpContext): Observable<EnedisConnectionConfig> {
    return this.getEnedisConnectionConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<EnedisConnectionConfig>): EnedisConnectionConfig => r.body)
    );
  }

  /** Path part for operation `updateEnedisConnectionConfiguration()` */
  static readonly UpdateEnedisConnectionConfigurationPath = '/stations/{uid}/enedis/{enedisUid}';

  /**
   * Update a station Enedis connection configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEnedisConnectionConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEnedisConnectionConfiguration$Response(params: UpdateEnedisConnectionConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateEnedisConnectionConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a station Enedis connection configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEnedisConnectionConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEnedisConnectionConfiguration(params: UpdateEnedisConnectionConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.updateEnedisConnectionConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeEnedisConnectionConfiguration()` */
  static readonly RemoveEnedisConnectionConfigurationPath = '/stations/{uid}/enedis/{enedisUid}';

  /**
   * Remove the station Enedis connection configuration.
   *
   * Remove Enedis connection configuration
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeEnedisConnectionConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeEnedisConnectionConfiguration$Response(params: RemoveEnedisConnectionConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeEnedisConnectionConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove the station Enedis connection configuration.
   *
   * Remove Enedis connection configuration
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeEnedisConnectionConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeEnedisConnectionConfiguration(params: RemoveEnedisConnectionConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.removeEnedisConnectionConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportEnedisConnectionTags()` */
  static readonly ExportEnedisConnectionTagsPath = '/stations/{uid}/enedis/configuration/{enedisUid}/export';

  /**
   * Export the tags of the Enedis connection of a station.
   *
   * Allows to export the tags of the Enedis connection of a station, via a XLS File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportEnedisConnectionTags()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportEnedisConnectionTags$Response(params: ExportEnedisConnectionTags$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportEnedisConnectionTags(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the tags of the Enedis connection of a station.
   *
   * Allows to export the tags of the Enedis connection of a station, via a XLS File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportEnedisConnectionTags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportEnedisConnectionTags(params: ExportEnedisConnectionTags$Params, context?: HttpContext): Observable<Blob> {
    return this.exportEnedisConnectionTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `importEnedisConnectionTags()` */
  static readonly ImportEnedisConnectionTagsPath = '/stations/{uid}/enedis/configuration/{enedisUid}/import';

  /**
   * Import and create the tags of the Enedis connection of a station.
   *
   * Allows to import and create the tags of the Enedis connection of a station, via a XLS File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importEnedisConnectionTags()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importEnedisConnectionTags$Response(params: ImportEnedisConnectionTags$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importEnedisConnectionTags(this.http, this.rootUrl, params, context);
  }

  /**
   * Import and create the tags of the Enedis connection of a station.
   *
   * Allows to import and create the tags of the Enedis connection of a station, via a XLS File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importEnedisConnectionTags$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importEnedisConnectionTags(params: ImportEnedisConnectionTags$Params, context?: HttpContext): Observable<void> {
    return this.importEnedisConnectionTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getEnedisErrorHistory()` */
  static readonly GetEnedisErrorHistoryPath = '/enedis/errorHistory';

  /**
   * Get all the statuses for Enedis connections acquistions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEnedisErrorHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnedisErrorHistory$Response(params?: GetEnedisErrorHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<EnedisConnectionErrorHistoryPagedList>> {
    return getEnedisErrorHistory(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all the statuses for Enedis connections acquistions.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEnedisErrorHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnedisErrorHistory(params?: GetEnedisErrorHistory$Params, context?: HttpContext): Observable<EnedisConnectionErrorHistoryPagedList> {
    return this.getEnedisErrorHistory$Response(params, context).pipe(
      map((r: StrictHttpResponse<EnedisConnectionErrorHistoryPagedList>): EnedisConnectionErrorHistoryPagedList => r.body)
    );
  }

  /** Path part for operation `getEnedisConnectionErrorHistory()` */
  static readonly GetEnedisConnectionErrorHistoryPath = '/enedis/connection/{uid}/errorHistory';

  /**
   * Get all the statuses for Enedis connections acquistions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEnedisConnectionErrorHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnedisConnectionErrorHistory$Response(params: GetEnedisConnectionErrorHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<EnedisConnectionErrorHistoryPagedList>> {
    return getEnedisConnectionErrorHistory(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all the statuses for Enedis connections acquistions.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEnedisConnectionErrorHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnedisConnectionErrorHistory(params: GetEnedisConnectionErrorHistory$Params, context?: HttpContext): Observable<EnedisConnectionErrorHistoryPagedList> {
    return this.getEnedisConnectionErrorHistory$Response(params, context).pipe(
      map((r: StrictHttpResponse<EnedisConnectionErrorHistoryPagedList>): EnedisConnectionErrorHistoryPagedList => r.body)
    );
  }

  /** Path part for operation `getEnedisAcquisitionStatuses()` */
  static readonly GetEnedisAcquisitionStatusesPath = '/enedis/acquisitionStatus';

  /**
   * Get all the statuses for Enedis connections acquistions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEnedisAcquisitionStatuses()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnedisAcquisitionStatuses$Response(params?: GetEnedisAcquisitionStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<EnedisAcquisitionStatusesPagedList>> {
    return getEnedisAcquisitionStatuses(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all the statuses for Enedis connections acquistions.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEnedisAcquisitionStatuses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnedisAcquisitionStatuses(params?: GetEnedisAcquisitionStatuses$Params, context?: HttpContext): Observable<EnedisAcquisitionStatusesPagedList> {
    return this.getEnedisAcquisitionStatuses$Response(params, context).pipe(
      map((r: StrictHttpResponse<EnedisAcquisitionStatusesPagedList>): EnedisAcquisitionStatusesPagedList => r.body)
    );
  }

}
